/**
 * opora-result-handoffs.js — Next-step rail after a successful tool run (D4 / Edge shells).
 * Calc-core owns manifest calculators; this fills #opHandoff on native D4 tool pages.
 */
(function (global) {
  'use strict';

  var MAP = {
    'job-costing-calculator': [
      { label: 'Bid Generator', url: '/pages/bid-generator', description: 'Package cost into a client price' },
      { label: 'Account profitability', url: '/pages/account-profitability-auditor', description: 'Check live margin by account' }
    ],
    'account-profitability-auditor': [
      { label: 'Churn cost', url: '/pages/churn-cost-calculator', description: 'What losing this account costs' },
      { label: 'Price increase letter', url: '/pages/price-increase-letter', description: 'Raise rate without losing them' }
    ],
    'rfp-decoder': [
      { label: 'Draft the response', url: '/pages/bid-drafter', description: 'Turn findings into a proposal' },
      { label: 'Price the scope', url: '/pages/bid-generator', description: 'Lock numbers behind the prose' }
    ],
    'bid-drafter': [
      { label: 'Decode the RFP first', url: '/pages/rfp-decoder', description: 'Catch red flags before you send' },
      { label: 'Bid Generator', url: '/pages/bid-generator', description: 'Rebuild the pricing sheet' }
    ],
    'bid-generator': [
      { label: 'Draft the full proposal', url: '/pages/bid-drafter', description: 'Client-ready narrative' },
      { label: 'Stress-test the margin', url: '/pages/bid-stress-test', description: 'What if labor rises 10%?' }
    ],
    'production-rate-calculator': [
      { label: 'Price the hours', url: '/pages/bid-generator', description: 'Turn FTE into an annual bid' },
      { label: 'Set the bill rate', url: '/pages/bill-rate-calculator', description: 'Burden wage into a sell rate' }
    ],
    'bill-rate-calculator': [
      { label: 'Price the contract', url: '/pages/bid-generator', description: 'Use this rate in a full bid' },
      { label: 'Staff the building', url: '/pages/production-rate-calculator', description: 'Convert sqft into FTE' }
    ],
    'dilution-calculator': [
      { label: 'Chemical compatibility', url: '/pages/chemical-compatibility', description: 'Avoid incompatible mixes' },
      { label: 'VOC compliance', url: '/pages/voc-compliance', description: 'State limits for this chemistry' }
    ],
    'voc-compliance': [
      { label: 'PPE selector', url: '/pages/ppe-selector', description: 'Protect the crew' },
      { label: 'Dilution calculator', url: '/pages/dilution-calculator', description: 'Dose concentrate correctly' }
    ],
    'ppe-selector': [
      { label: 'VOC compliance', url: '/pages/voc-compliance', description: 'Confirm product limits' },
      { label: 'SDS Finder', url: '/pages/sds-finder', description: 'Pull the safety data sheet' }
    ]
  };

  function esc(s) {
    return String(s == null ? '' : s)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function detectSlug() {
    var meta = document.querySelector('meta[name="opora:tool-slug"]');
    if (meta && meta.content) return meta.content;
    var el = document.querySelector('[data-tool], [data-slug], #_d4_tool_slug');
    if (el) {
      if (el.id === '_d4_tool_slug' && el.value) return el.value;
      return el.getAttribute('data-tool') || el.getAttribute('data-slug') || '';
    }
    var m = location.pathname.match(/\/pages\/([^\/\?]+)/);
    return m ? m[1] : '';
  }

  function renderInto(host, slug) {
    if (!host) return;
    var items = MAP[slug];
    if (!items || !items.length) {
      items = [
        { label: 'Browse all tools', url: '/pages/tools', description: '39 calculators and generators' },
        { label: 'Ask Opora', url: '/pages/ai', description: 'Cited answers for the next question' }
      ];
    }
    var html = '<div class="opora-next-rail" data-opora-next-rail>' +
      '<p class="opora-next-rail__label">After this result</p>' +
      items.map(function (h, idx) {
        return '<a class="opora-next-rail__link' + (idx === 0 ? ' opora-next-rail__link--primary' : '') +
          '" href="' + esc(h.url) + '">' +
          (idx === 0 ? '<span class="opora-next-rail__kicker">Next step</span>' : '') +
          '<strong>' + esc(h.label) + '</strong>' +
          (h.description ? '<span>' + esc(h.description) + '</span>' : '') +
          '</a>';
      }).join('') +
      '</div>';
    host.innerHTML = html;
    host.hidden = false;
    host.removeAttribute('hidden');
  }

  function showForSlug(slug) {
    slug = slug || detectSlug();
    // Manifest calculators already render a next-step rail via opora-calc-core.
    // Never double-mount a second "After this result" block on those pages.
    if (document.querySelector('[data-calc-handoffs], .calc-d4-handoffs')) return;

    var host = document.getElementById('opHandoff') || document.getElementById('opHandoffOpts');
    if (host && host.id === 'opHandoffOpts' && host.parentElement) host = host.parentElement;
    if (!host) {
      var result = document.querySelector('.d4-result-panel, #opResult');
      if (result && result.parentElement && !result.closest('.opora-calc')) {
        host = document.createElement('div');
        host.id = 'opHandoff';
        result.parentElement.insertBefore(host, result.nextSibling);
      }
    }
    if (host) renderInto(host, slug);
  }

  function watchNativeResults() {
    // Skip pages owned by the calc-core handoff rail.
    if (document.querySelector('[data-calc-handoffs], .calc-d4-handoffs, .opora-calc')) return;
    var panels = document.querySelectorAll('.d4-result-panel, #opResult');
    if (!panels.length || !global.MutationObserver) return;
    panels.forEach(function (panel) {
      var obs = new MutationObserver(function () {
        var visible = panel.classList.contains('d4-visible') ||
          panel.getAttribute('aria-busy') === 'false' ||
          (panel.textContent || '').trim().length > 40;
        if (visible) showForSlug(detectSlug());
      });
      obs.observe(panel, { childList: true, subtree: true, attributes: true, attributeFilter: ['class', 'aria-busy'] });
    });
  }

  document.addEventListener('opora:tool-rendered', function (e) {
    showForSlug((e.detail && e.detail.slug) || detectSlug());
  });

  document.addEventListener('DOMContentLoaded', function () {
    watchNativeResults();
    document.addEventListener('click', function (e) {
      var link = e.target.closest && e.target.closest('[data-opora-next-rail] a, .calc-d4-handoff-link');
      if (!link) return;
      try {
        if (global.gtag) global.gtag('event', 'tool_handoff_click', { link: link.getAttribute('href') || '' });
        else if (global.dataLayer) global.dataLayer.push({ event: 'tool_handoff_click', link: link.getAttribute('href') || '' });
      } catch (err) {}
    });
  });

  global.OporaResultHandoffs = { show: showForSlug };
})(typeof window !== 'undefined' ? window : this);
